import { SelectOption } from 'app/components/v2/components/Select';

const uppercaseRegex = /([A-Z])/g;
const numberRegex = /([0-9]+)/g;
const whitespaceRegex = /\s+/g;

const parseLabel = (value: string) => {
  return value
    .replace(uppercaseRegex, ' $1')
    .replace(numberRegex, ' $1 ')
    .replace(whitespaceRegex, ' ')
    .trim();
};

const getLabelFromEnumValue = (value: string): string => {
  const parsedLabel = parseLabel(value);

  return `${parsedLabel.charAt(0).toUpperCase()}${parsedLabel.slice(1)}`;
};

export const getEnumKeyAsString = (enumObj: Record<string, number | string>, value: number | string): string => {
  const key = Object.keys(enumObj).find(k => enumObj[k] === value);

  return key ? getLabelFromEnumValue(key) : '';
};

export const mapEnumToSelectOptionArray = (enumObj: Record<string, number | string>): SelectOption[] => {
  return Object.keys(enumObj).reduce((acc, key): SelectOption[] => {
    const parsedKey = Number(key);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const value = enumObj[key]!;

    // numeric enum
    if (!isNaN(parsedKey) && isNaN(Number(value))) {
      return [
        ...acc,
        {
          label: getLabelFromEnumValue(value.toString()),
          value: enumObj[value] as number,
        },
      ];
    } else if (isNaN(parsedKey) && !isNaN(Number(value))) {
      // this skips the reverse lookup from numeric enums
      return acc;
    }

    // string enum
    return [
      ...acc,
      {
        label: getLabelFromEnumValue(key),
        value,
      },
    ];
  }, []);
};
